import { render } from "./EditPersonnellePage.vue?vue&type=template&id=6f1c23a5&ts=true"
import script from "./EditPersonnellePage.vue?vue&type=script&lang=ts"
export * from "./EditPersonnellePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__